var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 7.69677C28.9694 8.13402 27.8637 8.43055 26.7018 8.56294C27.8881 7.88274 28.7962 6.80383 29.2266 5.52219C28.1138 6.1521 26.8855 6.6095 25.5768 6.85745C24.5287 5.78692 23.038 5.12012 21.3845 5.12012C18.2124 5.12012 15.6404 7.58287 15.6404 10.6186C15.6404 11.0491 15.6911 11.4696 15.7891 11.8718C11.016 11.6422 6.78357 9.45255 3.95085 6.12529C3.45568 6.93618 3.17399 7.88103 3.17399 8.88962C3.17399 10.7978 4.18881 12.4816 5.72854 13.4666C4.78719 13.4365 3.90185 13.1885 3.12677 12.7764V12.8451C3.12677 15.5089 5.10741 17.732 7.73365 18.238C7.25248 18.362 6.74509 18.4307 6.22018 18.4307C5.84927 18.4307 5.49058 18.3955 5.13889 18.3285C5.87023 20.5148 7.99086 22.1047 10.5034 22.1483C8.53851 23.6226 6.06097 24.4988 3.36999 24.4988C2.90634 24.4988 2.44965 24.472 2 24.4234C4.54228 25.9865 7.56048 26.8979 10.8044 26.8979C21.3706 26.8979 27.1463 18.5178 27.1463 11.2502L27.1271 10.5382C28.2556 9.76749 29.2319 8.79915 30 7.69677Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.72808433.svg";
export { ForwardRef as ReactComponent };